<div (click)="clicked()" [ngClass]="{ loading: loading }" class="inner">
  @if (!loading) {
    <img [src]="icon" />
  }
  @if (loading) {
    <span class="bubble">
      @if (loading) {
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="3"></circle>
        </svg>
      }
    </span>
  }
</div>
